import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'

export const Loader = () => (
  <div className="loader-container">
    <CircularProgress />
  </div>
)
